"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BrakeLiningError = function BrakeLiningError(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.51,8.47a.69.69,0,0,1-.64-.94A12,12,0,0,1,3.1,3.95a.69.69,0,1,1,1,.92A10.6,10.6,0,0,0,2.15,8,.69.69,0,0,1,1.51,8.47Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.88,14.7a.69.69,0,0,1-.68-.57,12.12,12.12,0,0,1,0-4.3.69.69,0,1,1,1.35.24,10.77,10.77,0,0,0,0,3.81.69.69,0,0,1-.55.8Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.61,20.25A.69.69,0,0,1,3.1,20,12,12,0,0,1,.87,16.45a.69.69,0,0,1,1.28-.51,10.59,10.59,0,0,0,2,3.16.69.69,0,0,1-.51,1.15Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.42,20.25a.69.69,0,0,1-.51-1.15,10.59,10.59,0,0,0,2-3.17.69.69,0,1,1,1.28.51A12,12,0,0,1,20.93,20,.69.69,0,0,1,20.42,20.25Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.15,14.7H23a.69.69,0,0,1-.55-.8,10.77,10.77,0,0,0,0-3.81.69.69,0,1,1,1.35-.24,12.12,12.12,0,0,1,0,4.3A.69.69,0,0,1,23.15,14.7Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.52,8.47A.69.69,0,0,1,21.88,8a10.58,10.58,0,0,0-2-3.16.69.69,0,1,1,1-.92,12,12,0,0,1,2.23,3.57.69.69,0,0,1-.64.94Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.15,4.47A7.52,7.52,0,1,1,4.66,12a7.51,7.51,0,0,1,7.49-7.52m0-1.37A8.89,8.89,0,1,0,21,12a8.88,8.88,0,0,0-8.87-8.89Z",
    style: {
      fill: '#e5352b'
    }
  }));
};

var _default = BrakeLiningError;
exports["default"] = _default;